import { observable } from 'mobx'
import Product from './Product'

class Licence {
    @observable licenceCount

    constructor({
        licenceCount,
        productType,
        products = [],
    }) {
        this.licenceCount = licenceCount
        this.productType = productType
        this.products = products.map((p) => new Product(p))
    }

    toJSON() {
        return {
            licenceCount: this.licenceCount,
            productType: this.productType,
            products: [],
        }
    }
}

export default Licence
